import pubsub from '../pubsub/pubsub';

/**
 * Autosubmit
 * A plugin that adds autosubmit functionality..
 * @version 3.0.0
 * @exports AutoSubmit
 */
export default class AutoSubmit {
    /**
     * Constructor
     * @public
     */
    constructor() {
        this._initAutosubmit();
        this._initSubscriptions();
    }

    /**
     * Function that initiates the autosubmit functionality.
     * This can be used on an input to have it to submit the form on change.
     * @private
     */
    _initAutosubmit() {
        const els = document.querySelectorAll('[data-type="autosubmit"]');

        els.forEach(el => {
            if (el.getAttribute('data-initiated') !== null) {
                return false;
            }

            el.setAttribute('data-initiated', true);

            el.addEventListener('change', handleChange);
        });
    }

    /**
     * Initiates subscriptions.
     * @private
     */
    _initSubscriptions() {
        pubsub.subscribe('/ajaxForm/sync/updated', this._initAutosubmit);
    }
}

export const handleChange = e => {
    const form = e.target.form;
    if (form) {
        if (form.getAttribute('data-type') === 'ajaxForm') {
            pubsub.publish('/ajaxForm/load');
        } else {
            form.submit();
        }
    }
};
